import React, { useEffect, useRef } from 'react';
import { IBoxConstraints } from './interfaces';

interface IProps {
  percent: number;
  boxConstraints: IBoxConstraints;
  inverse?: boolean;
}

export function Zone(props: IProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = props.inverse ? 'rgba(0, 0, 0, 0.31)' : 'rgba(255, 255, 255, 0.31)';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    const centerOffset = {
      x: props.boxConstraints.maxWidth * 0.5,
      y: props.boxConstraints.maxHeight * 0.5,
    };
    const radius = (props.boxConstraints.maxWidth / 2) * (props.percent / 100);
    if (radius < 0) return;
    ctx.beginPath();
    ctx.arc(centerOffset.x, centerOffset.y, radius, 0, 2 * Math.PI);

    ctx.stroke();
    ctx.closePath();
  }, [props.boxConstraints, props.inverse]);

  return (
    <canvas
      style={{ position: 'absolute', top: 0, left: 0 }}
      ref={canvasRef}
      width={`${props.boxConstraints.maxWidth}`}
      height={`${props.boxConstraints.maxHeight}`}
    />
  );
}
